import { Component, OnInit, Inject, ViewChild, ElementRef, Renderer2} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder, ValidatorFn } from '@angular/forms';
import { GlobalService } from '../../../services/global.service';
import { SnackBarService } from '../../../shared/snackbar/snackbar.service';
import Utils from '../../../shared/utility';
import { BasicQuestionComponent } from '../basic-question/basic-question.component';

@Component({
  selector: 'add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.css']
})
export class AddCategoryComponent implements OnInit {  
  categoryForm: FormGroup;
  docArr;
  passedValue;
  type;
  error;

  constructor(private matDialog: MatDialog, @Inject(MAT_DIALOG_DATA) data, private globalService: GlobalService, private snackBarService: SnackBarService, 
  private formBuilder: FormBuilder, private dialogRef: MatDialogRef<AddCategoryComponent>) {
    this.docArr = data.docArr;
    this.type = data.type;
    if(data.value != null || data.value != ''){
      this.passedValue = data.value;
    }
  }

  ngOnInit() {
    this.categoryForm = this.formBuilder.group({
      name: [(this.passedValue) ? this.passedValue : '', Validators.required]
    });
  }

  close(isEdited): void {
    this.dialogRef.close(isEdited);
  }

  save(isDeleteCategory = false) {
    if(isDeleteCategory){
      //delete/remove
      const dialogRef = this.matDialog.open(BasicQuestionComponent, {     
        data: { title: 'Removing a Category', question: 'Are you sure you want to remove the category titled: <b>' + this.passedValue + '</b>?<br/><b>This cannot be undone, and will remove all documents under this category</b>.' }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if(result){
          this.close({ saved: true, delete: true });
        }
      });
      //this.close({ saved: true, delete: true });
    } else {
      //saving
      if(this.passedValue){
        //editing
        this.close({ saved: true, delete: false, value: this.categoryForm.value.name });
      } else {
        //saving
        this.docArr.unshift({
          category: this.categoryForm.value.name.trim(),
          items: [],
        });

        const oldFormat = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.docArr);

        if (this.type === 'marketing-material') {
          this.saveMM(oldFormat);
        } else if (this.type === 'info-center') {
          this.saveIC(oldFormat);
        }
      }
    }
  }

  saveIC(oldFormat) {    
     this.globalService.ReplaceInfoCenter(oldFormat)
       .subscribe(
         resp => {
           if (resp) {
             this.snackBarService.add('Your document has been updated', 0);
           } else {
             this.snackBarService.add('An error occurred - please contact support', 1);
           }
           //this.confirmDeleteVisible = false;
           this.close(false);
         },
         error => this.error = <any>error);
  }

  saveMM(oldFormat) {
    this.globalService.ReplaceMarketingMaterial(oldFormat)
      .subscribe(
        resp => {
          if (resp) {
            this.snackBarService.add('Your document has been updated', 0);
          } else {
            this.snackBarService.add('An error occurred - please contact support', 1);
          }
          //this.confirmDeleteVisible = false;
          this.close(false);
        },
        error => this.error = <any>error);
  }

}
